import { Link } from 'react-router-dom';
import { formatCurrency } from '../../utils/formatting';

export default function ProductCard({ product, onSelect, disabled }) {
  const imageUrl = product.image_url || `https://via.placeholder.com/400x300.png?text=${product.name.replace(/ /g, '+')}`;

  return (
    <div className="border dark:border-gray-700 rounded-lg shadow-lg overflow-hidden flex flex-col bg-white dark:bg-gray-800 transition-transform duration-300 hover:-translate-y-1">
      <div className="w-full h-48 bg-gray-200 dark:bg-gray-700">
        <img src={imageUrl} alt={product.name} className="w-full h-full object-cover" />
      </div>
      <div className="p-4 flex flex-col flex-grow text-left">
        <h3 className="text-lg font-bold text-gray-800 dark:text-white">{product.name}</h3>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 flex-grow min-h-[60px]">
          {product.description ? `${product.description.substring(0, 100)}...` : 'No description available.'}
        </p>
        
        {/* ✅ THIS IS THE FIXED SECTION */}
        {/* We've changed from a row to a stacked column layout */}
        <div className="mt-4 space-y-3">
          <div>
            <p className="text-xs text-gray-500">Price</p>
            <p className="text-2xl font-extrabold text-orange-500">
               {formatCurrency(product.price)}
            </p>
          </div>
          <button
            onClick={() => onSelect(product)}
            disabled={disabled}
            className="w-full bg-orange-500 text-white font-bold py-3 px-4 rounded-lg hover:bg-orange-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Select this Item
          </button>
        </div>
      </div>
    </div>
  );
}